<ng-container *ngIf="data">
  <x-header-layout headingAlignment="left" class="p-2 border-bottom-color pe-0">
    <h3 xHeading>{{ data.address.alias ?? 'Address' }}</h3>
    <x-close-button xActionRight (click)="closeDialog()"></x-close-button>
  </x-header-layout>

  <div class="address-detail p-3">
    <table>
      <tr>
        <td>Name:</td>
        <td>{{ data.address.firstName }}</td>
      </tr>
      <tr>
        <td>Surname:</td>
        <td>{{ data.address.lastName }}</td>
      </tr>
      <tr>
        <td>Contact Numer:</td>
        <td>{{ data.address.phoneNumber }}</td>
      </tr>
      <tr>
        <td>Address:</td>
        <td>{{ data.address | shopAddress }}</td>
      </tr>
    </table>
  </div>

  <x-address-map
    mapHeight="500px"
    [defaultCoordinates]="data.address.coordinates"
    [defaultZoom]="15"
    [addressMarker]="data.address.coordinates"
    [dragMarker]="false"
  >
    <x-loader xLoader></x-loader>
  </x-address-map>
</ng-container>
